import axios from "axios";
import { EDownloadSource } from "./DownloadButton";
import REACT_APP_API_URL from "../../../../Api/ApiEnvironment";

export enum EDownloadFileExtention {
    WORD = 'docx',
    PDF = 'pdf'
}

export const downloadApiCall = async (downloadId: string, filename: string, extention: EDownloadFileExtention, source: EDownloadSource, token: string) => {
    
    const getEndpoint = () => {
        console.log('source', source);
        switch (source) {
            case EDownloadSource.DRAFT:
                if ( extention === EDownloadFileExtention.PDF )
                    return `/drafts/${downloadId}/download`;
                return `/drafts/${downloadId}/download/docx`;
            case EDownloadSource.TEMPLATE:
                    return `/drafts/templates/${downloadId}/download`;
            default:
                return '';
        }
    }

    try {
        const response = await axios.get(`${REACT_APP_API_URL}${getEndpoint()}`, {
            headers: {
                Authorization: `Bearer ${token}`
            },
            responseType: 'blob'
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        
        fileLink.href = fileURL;
        fileLink.setAttribute('download', `${filename}.${extention}`);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
    } catch (error) {
        console.log(error);
    }
}